import { createContext, useState, useEffect } from "react";

export const SellerContext = createContext();

export const SellerProvider = ({ children }) => {
  const [sellerPhone, setSellerPhone] = useState(null);

  return (
    <SellerContext.Provider value={{ sellerPhone, setSellerPhone }}>
      {children}
    </SellerContext.Provider>
  );
};